// https://www.figma.com/file/q7KlcLyYFswO2QB3I4BWmE/Interests-Graph-on-Web?node-id=4%3A2496
import { css, cx } from '@fable/theme'
import EmptyState from '../../../../components/empty_state/EmptyState'
import { EMPTY_STATE_TYPES } from '../../../../constants'

const ProfileContentPrivate: React.VFC = () => {
  const emptyType = EMPTY_STATE_TYPES.social

  return (
    <div
      className={cx(
        css`
          .empty-state {
            background-size: cover !important;
            height: 500px;
          }
        `,
        'fade'
      )}
    >
      <EmptyState
        accentColor={emptyType.accentColor}
        bgImage={emptyType.bgImage}
        description={emptyType.description}
        mainImage={emptyType.mainImage}
      />
    </div>
  )
}

export default ProfileContentPrivate
